<template>
    <li class="cart-layer toLayerPanier">
        <a id="cart-widget" @click="show({isNotification: isNotification})">
            <img src="/bundles/site/img/shopping-bag-regular.svg" class="svg" alt="Panier">
            <span class="d-none d-lg-block">Panier </span>
            <em>{{ countItems }}</em>
        </a>

        <nav class="cbp-spmenu cbp-spmenu-vertical cbp-spmenu-right" id="cbp-spmenu-s2">
            <div id="layerHeader">
                <span @click="hide()" id="close-panel">×</span>
            </div>

            <div v-if="isNotification" class="info added text-center">
                <img src="/bundles/site/img/icoCheckCart.svg" class="svg" alt="Produit ajouté au panier"/>
                Produit ajouté au panier
            </div>

            <div v-if="isEmpty" class="info empty text-center">
                Votre panier est vide.
            </div>

            <div id="layerPanier">
                <div id="cart">
                    <div class="zoneScroll">
                        <ponroy-cart-widget-item
                                v-for="item in items"
                                v-if="null !== item.orderable && 'site.repository.product_reference' === item.orderable.orderableRepository"
                                :type="item.orderable.orderableRepository"
                                :key="item.id"
                                :reference="item.id"
                                :title="item.orderable.data.title"
                                :referenceTitle="item.referenceName"
                                :total="item.total"
                                :unitsTotal="item.unitsTotal"
                                :quantity="item.quantity"
                                :mainImage="item.orderable.data.cardImage"
                        ></ponroy-cart-widget-item>
                        <ponroy-cart-widget-item
                                v-for="item in items"
                                v-if="null !== item.orderable && 'site.repository.fidelity_gift' === item.orderable.orderableRepository"
                                :type="item.orderable.orderableRepository"
                                :key="item.id"
                                :reference="item.id"
                                :title="item.orderable.title"
                                :total="item.totalFidelityPoint"
                                :unitsTotal="0"
                                :quantity="item.quantity"
                                :mainImage="item.orderable.image"
                        ></ponroy-cart-widget-item>
                        <ponroy-cart-widget-item
                                v-for="item in items"
                                v-if="null !== item.orderable && 'site.repository.gift' === item.orderable.orderableRepository && item.orderable.type !== 'sample' && item.orderable.type !== 'doc'"
                                :type="item.orderable.orderableRepository"
                                :key="item.id"
                                :reference="item.id"
                                :title="item.orderable.title"
                                :total="item.total"
                                :unitsTotal="item.unitsTotal"
                                :quantity="item.quantity"
                                :mainImage="item.orderable.image"
                        ></ponroy-cart-widget-item>

                      <div id="recos" v-if="0 < filtredRecommendedProducts.length">
                        <div class="titleRecos">Nous vous recommandons</div>

                        <div class="zoneRecos">
                          <div v-for="item in recommendedProductForLayer" class="miniProduct" v-if="!inCart(item.id)">
                            <a @click="showProduct(item.product.id, item.product.slug)">
                              <div class="row" style="align-items: center">
                                <div class="col-4" style="padding-right: 0">
                                  <img v-if="item.product.catalogImage" :data-src="item.product.catalogImage.path" :alt="item.product.title" class="lazyload img-fluid">
                                </div>
                                <div class="col-8">

                                  <div>
                                    <span v-if="item.product.isNewFormula" class="badge badge-secondary">Nouvelle formule</span>
                                    <span v-if="item.product.isNew" class="badge badge-secondary">Nouveauté</span>
                                    <span v-if="item.product.bestSales" class="badge badge-secondary">Meilleures ventes</span>
                                    <span v-if="item.product.provenSatisfaction" class="badge badge-secondary">Satisfaction prouvée</span>
                                    <span v-if="item.product.provenEffectiveness" class="badge badge-secondary">Efficacité prouvée</span>
                                  </div>

                                  <strong>
                                                <span v-if="item.name">
                                                    {{ item.name }} -
                                                </span>
                                    {{ item.product.title }}
                                  </strong>

                                  <span>{{ item.product.subtitle }}</span>
                                  <p class="prix">
                                    {{ (item.discountedPrice > 0 ? item.discountedPrice : item.price ) | moneyFormat }}

                                    <del v-if="item.discountedPrice > 0" style="font-weight: normal">
                                      {{ item.price | moneyFormat }}
                                    </del>
                                  </p>
                                </div>
                              </div>
                            </a>
                            <div class="text-right">
                              <button @click="addRecommendation(item)" type="button" class="btn btn-primary">Ajouter au panier</button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>



                    <div class="row bigTotal">
                        <div class="">Total de vos articles</div>
                        <div class="">{{ itemsTotalDiscounted | moneyFormat }}</div>
                    </div>

                    <div class="text-center benefices" v-if="discountAmount > 0">Vous bénéficiez de <strong>{{ discountAmount | moneyFormat }}</strong></div>
                    <div class="text-center benefices" v-if="shippingFees && 0 == shippingFees.amount">Vous bénéficiez de <strong>la livraison offerte</strong></div>

                    <a href="/panier" class="btn btn-primary show-cart">Voir mon panier</a>
                </div>
            </div>
        </nav>
    </li>
</template>

<script>

    import {mapState, mapActions, mapGetters} from 'vuex';
    import Routing from 'routing';
    import request from '../store/utils/request';

    import store from '../store';

    const CartSidebar = {
        name: 'ponroy-cart-sidebar',
        store,
        computed: {
            ...mapGetters('cart', [
                'widgetVisible',
                'isNotification',
                'items',
                'itemsTotal',
                'itemsTotalDiscounted',
                'discountAmount',
                'total',
                'shippingFees',
                'recommendedProductForLayer',
                'countItems'
            ]),
            isEmpty: function () {
                return 0 === this.countItems;
            },
          filtredRecommendedProducts: function () {
            return this.recommendedProductForLayer.filter((item) => !this.inCart(item.id));
          }
        },
        watch: {
            widgetVisible(value) {
                let menuRight = document.getElementById('cbp-spmenu-s2');
                classie.toggle(menuRight, 'cbp-spmenu-open');
            },
            isNotification(value) {
                if (true === value) {
                    let hide = this.hideNotification;
                    setTimeout(function() {
                        hide()
                    }, 2000);
                }
            }
        },
        methods: {
            ...mapActions('cart', {
                hide: 'hideWidget',
                show: 'showWidget',
                hideNotification : 'hideNotification',
                addToCart: 'addToCart',
            }),
            showProduct(id, slug) {

                // window._ebq = window._ebq || [];
                // window._ebq.push(['trackActivity', {
                //     original_id: this.id,
                //     verb: 'click-on-reco',
                //     type: 'product',
                //     widgetId: '5b4f0929ae3c2856daa3f723'
                // }]);

                window.location.href = Routing.generate('site_product_show', { 'id': id, 'slug' : slug });
            },

            async addRecommendation(item) {
                this.addToCart({
                    orderable: {
                        repository: 'site.repository.product_reference',
                        id: item.id.toUpperCase()
                    },
                    'quantity': 1
                });

                // window._ebq = window._ebq || [];
                // window._ebq.push(['trackActivity', {
                //     original_id: item.id,
                //     verb: 'click-on-reco',
                //     type: 'product',
                //     widgetId: '5b4f0929ae3c2856daa3f723'
                // }]);
            },

          inCart: function(needle) {

            let length = 0;

            if (this.items) {
              length = this.items.length;
            }

            for(let i = 0; i < length; i++) {
              if(this.items[i].orderableId === needle) return true;
            }

            return false;
          },
        },
    };

    export default CartSidebar;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartSidebar.vue